<template>
    <div class="bodat">
        <div class="top">
            <div class="page-title">订单查询</div> 
            <div class="user-info">
                <p class="user-info-para">姓名：{{nikeName}}</p> 
                <p class="user-info-para">联系电话：{{takePhone}}</p>
            </div>
            <div class="order-list">
                <div class="order-block" v-for="item in dataList" :key="item.id">
                    <p class="goods-name">{{item.takeNickname}}</p>
                    <div class="order-info-para clear">
                        <p class="order-info-title">我方单号：</p> 
                        <p class="order-info-content">
                            {{item.id}}
                            <span :data-clipboard-text="item.id" class="copy-btn right copy_id" @click="copy()">复制订单号</span>
                        </p>
                    </div>
                    <div class="order-info-para clear">
                        <p class="order-info-title">快递单号：</p> 
                        <p class="order-info-content">
                            {{item.disposeRemark}}
                            <span :data-clipboard-text="item.disposeRemark" class="copy-btn right copy_emsCode" @click="copy1()">复制快递号</span>
                        </p>
                    </div>
                    <div class="order-info-para clear">
                        <p class="order-info-title">订单状态：</p> 
                        <div class="order-info-content">
                            <span class="status-red" v-if="item.disposeState === 7 || item.disposeState === 8">{{item.stateName}}</span>
                            <span class="status-lv" v-else>{{item.disposeStateName}}</span>
                        </div>
                    </div>
                    <div class="order-info-para clear">
                        <p class="order-info-title">收货地址：</p> 
                        <div class="order-info-content">
                            <span class="status-red">{{item.takeAddress}}</span>
                        </div>
                    </div>
                      <div class="order-info-para clear">
                        <p class="order-info-title">订单时间：</p> 
                        <p class="order-info-content">{{item.createTime}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import Clipboard from 'clipboard';
import { Toast } from 'vant';
export default {
    data(){
        return{
            dataList:{},
            nikeName:'',
            takePhone:''
        }
    },
    created(){
        this.loadget()
    },
    methods:{
        loadget(){
            var params={
	            takePhone:this.$route.query.takePhone
            }
            wxRequest('applyChangeSim/apply/sim/select',params,'post').then(res => {
                if(res.data.code == 200){
                   this.dataList  = res.data.data
                     var result = res.data.data;
                     for(let i=0; i<result.length; i++){
                        this.nikeName=result[i].takeNickname;
                        this.takePhone=result[i].takePhone;
                     }
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_id')
            clipboard.on('success', e => {
              Toast.fail('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                Toast.fail('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        copy1() {
            var clipboard = new Clipboard('.copy_emsCode')
            clipboard.on('success', e => {
              Toast.fail('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                Toast.fail('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
    }
}
</script>
<style lang="less" scoped>
    .bodat{
        background: #F5F5F5;
        height:100vh;
        .top {
            height:150px;
            background: -webkit-linear-gradient(45deg, #698DFD 0%, #556EFC 100%);
            background: -moz-linear-gradient(45deg, #698DFD 0%, #556EFC 100%);
            background: -o-linear-gradient(45deg, #698DFD 0%, #556EFC 100%);
            background: linear-gradient(45deg, #698DFD 0%, #556EFC 100%);
            padding: 0 15px;
        }

        .page-title {
            font-size: 18px;
            text-align: center;
            color: #fff;
            line-height:32px;
            padding-top:7px;
        }
        .user-info {
	        margin-top: 4px;
            .user-info-para {
                line-height: 26px;
                font-size: 15px;
                color: #fff;
            }
        }
        .order-list{
            width:90%;
            // margin: -52px auto 0;
            .order-block{
                width: 100%;
                background: #fff;
                border-radius: 10px;
                margin-bottom:12px;
                padding: 0 15px 12px 12px;
                .goods-name {
                    color: #333333;
                    font-size: 15px;
                    padding-left: 9px;
                    padding-top: 10px;
                    position: relative;
                    line-height: 29px;
                    &::before{
                        display: block;
                        content: '';
                        width: 2px;
                        height: 12px;
                        background: #2a70ff;
                        position: absolute;
                        left: 0;
                        top: 19px;
                    }
                }
                .order-info-para {
                    line-height: 26px;
                    display: flex;
                    .order-info-title {
                        width:70px;
                        float: left;
                        color: #999;
                        font-size: 12px;
                        text-align: right;
                    }
                    .order-info-content {
                        width: 240px;
                        color: #333;
                        font-size:12px;
                        float: left;
                    }
                    .copy-btn {
                        color: #5873FD;
                        font-size:11px;
                        float: right;
                        cursor: pointer;
                    }
                    .status-desc{
                        font-size:10px;
                        line-height:17px;
                        margin-top: -2px;
                    }
                    .status-red {
                        color: #FF161B;
                    }
                    .status-lv{
                        color:#0bbd28;
                    }
                }
            }
        }

    }
</style>